import React from "react";
import { object, func, bool } from "prop-types";
import { LazyLoadImages } from "@quintype/components";
import { StoryHeader } from "../../molecules";
import StoryElements from "../story-elements";
import "../../pages/story.m.css";
import { get } from "lodash";
import StickySidebar from "../../../arrow/components/Atoms/StickySidebar";

import "./movie-review.m.css";
import MoviewReviewCard from "../../molecules/MovieReviewCard";

const MovieReview = ({ story, config, adWidget, adPlaceholder, hasAccess, recommendedStories, magazineDetails }) => {
  const { headline, authors, "published-at": publishTime = "" } = story;

  const showMovieReview = () => {
    const metadata = get(story, ["metadata"]);
    const {
      "review-title": movieTitle = "",
      "review-rating": reviewRating = {},
      "director-name": directorName = "",
      producer = "",
      "music-director": musicDirector = "",
      cast = "",
    } = metadata;

    return reviewRating && directorName && producer;
  };

  return (
    <div styleName="story-template-container" className="story-holder">
      <StoryHeader
        story={story}
        headline={headline}
        storyAuthorData={authors}
        publishTime={publishTime}
        readTime={story?.["read-time"]}
        magazineDetails={magazineDetails}
        showReview={showMovieReview()}
      />
      <div className="story-elements">
        <div className="text-container" styleName="movie-review-text-container">
          <LazyLoadImages>
            {showMovieReview() && (
              <StickySidebar left0={true}>
                <MoviewReviewCard isSticky={true} reviewInfo={story.metadata} />
              </StickySidebar>
            )}
            <StoryElements
              story={story}
              cards={story.cards}
              recommendedStories={recommendedStories}
              isStickyReview={showMovieReview()}
              marginLeft={!!showMovieReview()}
              config={config}
            />
          </LazyLoadImages>
        </div>
      </div>
    </div>
  );
};
MovieReview.propTypes = {
  story: object,
  config: object,
  adWidget: func,
  adPlaceholder: object,
  hasAccess: bool,
};
export default MovieReview;
